import { gsap } from 'gsap';

const openText = () => {
  const btns = document.querySelectorAll('.faq_inner_item_btn');
  const panels = document.querySelectorAll('.faq_inner_item_text-box');

  btns.forEach((btn, idx) => {
    const panel = panels[idx];
    btn.addEventListener('click', () => {
      const isOpen = btn.classList.contains('active');
      if (!isOpen) {
        gsap.to(panel, {
          height: panel.scrollHeight,
          duration: 0.3,
          ease: 'back',
          onComplete: () => {
            panel.style.height = 'auto';
          },
        });
        btn.classList.add('active');
      } else {
        gsap.to(panel, {
          height: 0,
          duration: 0.3,
          ease: 'back',
        });
        btn.classList.remove('active');
      }
    });
  });
};

export default openText;
